export default __webpack_public_path__ + "static/case-study-a54c38704b79276d5d1aba2607a92ab1.png";